// UpdateInterval — per-gob update-skip scheduling. game/ht.h:695-743.
//
// DETERMINISM NOTE (ht.h:717-722): in MULTIPLAYER Decrement() always returns true — update
// intervals are SP-only because skip state depends on machine-local conditions (visibility,
// gpplrLocal). The fMultiplayer flag comes from the SimContext (the C++ reads the
// gfMultiplayer global).

export class UpdateInterval {
  private m_cSkip = 0;
  private m_cDecrementsLast = 0;
  private m_cDecrements = 0;

  // ht.h:708-714 — MinSkip() resets to 0; MinSkip(c) takes the min
  MinSkip(cSkip?: number): void {
    if (cSkip === undefined) this.m_cSkip = 0;
    else this.m_cSkip = Math.min(this.m_cSkip, cSkip); // _min on ints
  }

  // ht.h:716-739
  Decrement(fMultiplayer: boolean): boolean {
    if (fMultiplayer) return true;

    if (this.m_cSkip <= 0) {
      this.m_cSkip = 0x7fff;
      this.m_cDecrementsLast = this.m_cDecrements;
      this.m_cDecrements = 0;
      return true;
    }

    this.m_cSkip--;
    this.m_cDecrements++;
    return false;
  }

  // ht.h:741-745 — a skip of 0 (next update) is an update count of 1
  GetUpdateCount(): number {
    return this.m_cDecrementsLast + 1;
  }
}
